<template>
  <b-container>
    <b-form-group :label="$t('workflow.waypoint.waypointDocumentNumberLabel')" label-for="cnpj-input" calss="mb-4">
      <b-form-input id="cnpj-form" type="text" required v-model="model.companyDucumentNumber"
        :placeholder="$t('workflow.waypoint.waypointDocumentNumberLabel')"></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('workflow.waypoint.waypointName')" label-for="input-waypoint-name" class="mb-4">
      <b-form-input id="input-form-name" type="text" v-model="model.name" required
        :placeholder="$t('workflow.waypoint.waypointName')">
      </b-form-input>
      <span class="text-danger" v-if="modelstate['Name']">
        {{ modelstate["Name"][0] }}
      </span>
    </b-form-group>
    <b-form-group :label="$t('workflow.waypoint.waypointFullAddress')" label-for="input-waypoint-fullAddress"
      class="mb-4">
      <b-form-input id="input-form-name" type="text" v-model="model.fullAddress" required
        :placeholder="$t('workflow.waypoint.waypointFullAddress')">
      </b-form-input>
    </b-form-group>
    <!-- <div>markerCrud: {{ markerCrud }}</div> -->
    <!-- {{ model }} -->
    <div v-if="mapEngine === '0'">
      <leaflet-marker-crud :model.sync="markerCrud" :id="'map2'" />
    </div>
    <div v-if="mapEngine === '1'">
      <google-map-marker-crud :model.sync="markerCrud" :id="'map2'" />
    </div>
  </b-container>
</template>
<script>
export default {
  name: "WaypointCrud",
  props: {
    model: Object,
    modelstate: Object
  },
  components: {
    GoogleMapMarkerCrud: () =>
      import("@/components_rms/base/googlemaps/crud/GoogleMapMarkerCrud.vue"),
    LeafletMarkerCrud: () =>
      import("@/components_rms/base/leaflet/crud/LeafletMarkerCrud.vue")
  },
  data() {
    return {
      mapEngine: localStorage.getItem("mapEngine"),
      markerCrud: {
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0
      }
    };
  },
  watch: {
    markerCrud() {
      this.model.latitude = this.markerCrud.latitude;
      this.model.longitude = this.markerCrud.longitude;
    }
  }
};
</script>
